module.exports = __webpack_public_path__ + "static/media/custom-review-box.beac69d3.svg";